import { css } from '@utils/css';

const address = css`
  font-style: inherit;
`;

export { address };
//# sourceMappingURL=address.js.map
